import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Inject } from 'vue-di-container';
import WithRender from './UserManagement.html';
import UserManagementService from './UserManagementService';
import { FilterModel } from './FilterModel';
import { UserManagementModel } from './UserManagementModel';
import { Toaster } from '../../Services/toast';
import ValidationService from '../../Services/ValidationService';
import UserService from '../../shared/userService/UserService';
import UserRoleService from '../../shared/userService/UserRoleService';
import ProviderService from '../Provider/ProviderService';

@WithRender
@Component({
    components: {
    },
    diProvide: [
        UserManagementService,
        ProviderService,
    ],
})
export default class UserManagement extends Vue {
    @Inject(UserManagementService) public userManagementService!: UserManagementService;
    @Inject(ValidationService) public validationService!: ValidationService;
    @Inject(UserService) public userService!: UserService;
    @Inject(UserRoleService) public userRoleService!: UserRoleService;
    @Inject(ProviderService) public providerService!: ProviderService;
    @Prop({ type: Boolean, default: false })
    public layoutSup: boolean | any;
    public get showProviderNameColumn(): boolean {
        return this.userRole === 1 || this.userRole === 9;
    }

    public get headers(): any[] {
        const cols: any[] = [
            { text: this.$t('shared.userName'), value: 'username', align: 'center', sortable: false },
            { text: this.$t('shared.userEmail'), value: 'email', align: 'center', sortable: false },
            { text: this.$t('shared.phoneNumber'), value: 'mobileNumber', align: 'center', sortable: false },
            { text: this.$t('shared.type'), value: 'roleName', align: 'center', sortable: false },
        ];
        if (this.showProviderNameColumn) {
            cols.push({
                text: this.$t('userManagementPage.providerName'),
                value: 'providerName',
                align: 'center',
                sortable: false,
            });
        }
        cols.push(
            { text: this.$t('dashboardPage.status'), value: 'isLocked', align: 'center', sortable: false },
            { text: this.$t('shared.actions'), value: 'id', align: 'center', sortable: false, width: '75' },
        );
        return cols;
    }
    public get userRoleName(): string {
        return this.User && this.User.details ? this.User.details.Role : '';
    }

    /** Roles the current user may filter by (scoped by permission). */
    public get roleFilterOptions(): Array<{ id: number; name: string }> {
        const platformAdminFullList: Array<{ id: number; name: string }> = [
            { id: 1, name: 'Platform Admin' },
            { id: 2, name: 'Provider User' },
            { id: 3, name: 'CST Admin' },
            { id: 4, name: 'CST User' },
            { id: 5, name: 'Provider Admin' },
            { id: 6, name: 'Support' },
            { id: 7, name: 'Service' },
            { id: 8, name: 'Finance' },
            { id: 10, name: 'Monitor' },
            { id: 11, name: 'CST Tag Name' },
            { id: 14, name: 'API User330' },
        ];

        switch (this.userRole) {
            case 9:
                return [
                    ...platformAdminFullList,
                    { id: 9, name: 'Super Admin' },
                    { id: 15, name: 'Managing Requests' },
                    { id: 16, name: 'Fraud Management' },
                ];
            case 1:
                return [
                    ...platformAdminFullList,
                    { id: 15, name: 'Managing Requests' },
                    { id: 16, name: 'Fraud Management' },
                ];
            case 5:
                return [
                    { id: 5, name: 'Provider Admin' },
                    { id: 2, name: 'Provider User' },
                ];
            case 3:
                return [
                    { id: 3, name: 'CST Admin' },
                    { id: 4, name: 'CST User' },
                ];
            case 4:
                // Same scope as CST Admin listing: API can return CITC/CST Admin + User rows.
                return [
                    { id: 3, name: 'CST Admin' },
                    { id: 4, name: 'CST User' },
                ];
            case 6:
                return [{ id: 6, name: 'Support' }];
            case 8:
                return [{ id: 8, name: 'Finance' }];
            case 10:
                return [{ id: 10, name: 'Monitor' }];
            case 11:
                return [{ id: 11, name: 'CST Tag Name' }];
            case 14:
                return [{ id: 14, name: 'API User330' }];
            case 15:
                return [{ id: 15, name: 'Managing Requests' }];
            case 16:
                return [{ id: 16, name: 'Fraud Management' }];
            default:
                return [];
        }
    }
    public users: UserManagementModel[] = [];
    public usersCount: number = 0;
    public userId: string = '';
    public isLocked: boolean = false;
    public superUserDialog: boolean = false;
    public userName: string = '';
    public lockDialog: boolean = false;
    public resendPasswordDialog: boolean = false;
    public toggule: boolean = false;
    public userRole: number = 0;
    public User: any;
    public usersFiltered: UserManagementModel[] = [];
    public providerOptions: any[] = [];
    public filterModel: FilterModel = {
        username: '',
        mobile: '',
        email: '',
        role: [],
        providerName: '',
    };

    public created() {
        this.$emit('childinit', this.layoutSup);
    }

    public async mounted() {
        this.User = await this.userService.getUser();
        this.userRole = await this.userRoleService.GetUserRole(this.User);
        if (this.showProviderNameColumn) {
            const providerResponse = await this.providerService.Get('', '', '', '', '0', '10000');
            this.providerOptions = providerResponse.result || [];
        }
        this.search();
    }


    public async reset() {
        this.filterModel.username = '';
        this.filterModel.email = '';
        this.filterModel.mobile = '';
        this.filterModel.role = [];
        this.filterModel.providerName = '';
        this.search();
    }

    /** Same pattern as Dashboard — refresh list from server */
    public async reload() {
        await this.search();
    }

    public async exportUsers() {
        const result = await this.userManagementService.ExportUsers(
            this.filterModel.username,
            this.filterModel.email,
            this.filterModel.mobile,
            this.filterModel.role || [],
            this.filterModel.providerName || '',
        );
        if (result.success) {
            Toaster.success(this.$t('userManagementPage.exportSuccess').toString());
        } else {
            Toaster.error(result.errorMessage || this.$t('userManagementPage.exportFailed').toString());
        }
    }


    @Watch('filterModel', { deep: true })
    public async search() {
        const response = await this.userManagementService.Get
            (this.filterModel.username, this.filterModel.email, this.filterModel.mobile, this.filterModel.role, this.filterModel.providerName || '', '0', '10');
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
        }
        this.users = response.result;
        this.usersCount = response.totalCount;
    }
    public isEqual(value1: string | null, value2: string) {
        if (value2 === undefined) {
            value2 = '';
        }
        return (value1 === '' || value1 === null || value2.includes(value1));
    }
    public async filter(val: any) {
        const response = await this.userManagementService.Get
            (this.filterModel.username, this.filterModel.email, this.filterModel.mobile, this.filterModel.role, this.filterModel.providerName || '', '0', '10');
    }
    public async updatePaginate(val: any) {
        const response = await this.userManagementService.Get
            (this.filterModel.username, this.filterModel.email, this.filterModel.mobile, this.filterModel.role,
                this.filterModel.providerName || '',
                (val.page - 1).toString(), val.rowsPerPage);
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
        }
        this.users = response.result;
        this.usersCount = response.totalCount;
    }

    public showSuperUserDialog(evt: any, id: string) {
        evt.preventDefault();
        this.userId = id;
        this.superUserDialog = true;
    }

    public hideSuperUserDialog() {
        this.userId = '';
        this.superUserDialog = false;
    }
    public async saveSuperUser() {
        const response = await this.userManagementService.SwitchAdminToSuper(this.userId);
        if (response.isSuccess) {
            Toaster.success(this.$t('userManagementPage.EditUserSuccessfully').toString());
            this.search();
        } else {
            Toaster.error(response.errorMessage);
        }
        this.hideSuperUserDialog();
    }

    public showLockDialog(evt: any, id: string, isLocked: boolean) {
        evt.preventDefault();
        this.userId = id;
        this.isLocked = !isLocked;
        this.lockDialog = true;
    }

    public hideLockDialog() {
        this.userId = '';
        this.isLocked = false;
        this.lockDialog = false;
    }

    public showResendPasswordDialog(userName: string) {
        this.userName = userName;
        this.resendPasswordDialog = true;
    }

    public hideResendPasswordDialog() {
        this.userName = '';
        this.resendPasswordDialog = false;
    }

    public async saveShortCode() {
        const response = await this.userManagementService.SwitchLock(this.userId, this.isLocked);
        if (response.isSuccess) {
            this.hideLockDialog();
            Toaster.success(this.$t('userManagementPage.EditUserStatusSuccessfully').toString());
            this.search();
        } else {
            Toaster.error(response.errorMessage);
        }
    }

    public async resendPasswordEmail() {
        const response = await this.userManagementService.ResendPasswordEmail(this.userName);
        if (response.isSuccess) {
            this.resendPasswordDialog = false;
            Toaster.success(this.$t('userManagementPage.resendPasswordEmailSuccessfully').toString());
        } else {
            Toaster.error(response.errorMessage);
        }
    }

    public isNumberField(val: KeyboardEvent) {
        if (!this.validationService.isNumber(val.key)) {
            val.preventDefault();
        }
    }

    public isNumberFieldPaste(ev: any) {
        const paste = (ev.clipboardData).getData('text');
        if (isNaN(paste)) {
            ev.preventDefault();
        }
    }

}
